import inputExcelCopy from './inputExcelCopy.vue'
export default inputExcelCopy
